import { useConnectionTestStatus } from "./useConnectionTestStatus";
import { t } from "@/i18n";

/** Bağlantı testi adimi — POST /connection-test → job polling → checks
 * tablosu (gorev talimati madde 3). */
export function ConnectionTestStep() {
  const { runTest, isStarting, startError, isPolling, job } = useConnectionTestStatus();

  const isRunning = isStarting || (isPolling && (!job || job.status === "queued" || job.status === "running"));
  const checks = job?.result?.checks ?? {};
  const checkEntries = Object.entries(checks);

  return (
    <div className="space-y-3">
      <button
        type="button"
        onClick={() => void runTest()}
        disabled={isRunning}
        className="min-h-[44px] rounded-md bg-brand-primary px-4 text-sm font-semibold text-white disabled:opacity-60"
      >
        {isRunning ? t("kurulum.test.running") : t("kurulum.test.run")}
      </button>

      {startError && (
        <p role="alert" className="text-sm text-red">
          {t("common.error")}
        </p>
      )}

      {!job && !isRunning && <p className="text-sm text-muted">{t("kurulum.test.no_result")}</p>}

      {job && (job.status === "queued" || job.status === "running") && (
        <p className="text-sm text-muted">{t("kurulum.test.queued")}</p>
      )}

      {job && job.status === "done" && job.result && (
        <div className="space-y-2 rounded-xl border border-line p-4">
          <p className={`text-sm font-semibold ${job.result.ok ? "text-green" : "text-red"}`}>
            {job.result.ok ? t("kurulum.test.ok") : t("kurulum.test.failed")}
          </p>
          {job.result.message && <p className="text-xs text-muted">{job.result.message}</p>}
          {checkEntries.length > 0 && (
            <table className="w-full text-left text-sm">
              <thead className="text-xs uppercase text-muted">
                <tr>
                  <th className="py-1">{t("kurulum.test.checks")}</th>
                  <th className="py-1"></th>
                </tr>
              </thead>
              <tbody>
                {checkEntries.map(([key, value]) => (
                  <tr key={key} className="border-t border-line">
                    <td className="py-1 pr-2 text-ink">{key}</td>
                    <td className="py-1 text-muted">{String(value)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {job && (job.status === "failed" || job.status === "cancelled") && (
        <p role="alert" className="text-sm text-red">
          {job.last_error ?? t("kurulum.test.failed")}
        </p>
      )}
    </div>
  );
}
